// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LPCT","type":"styles_type__3B5-j","choices":"styles_choices__2Sj3r"};